import TerminaisPhoebus from "./terminaisPhoebus";
import {connect} from "react-redux";

export default connect()(TerminaisPhoebus)
